/** 囲み（docs/06 4-4）。白地・枠線・角丸のまとまり。見出しと説明を上に置ける。 */
import type { ReactNode } from 'react';

export interface CardProps {
  /** 囲みの見出し（省略可） */
  title?: ReactNode;
  /** 見出しの下の1〜2行の説明（省略可） */
  description?: ReactNode;
  /** 見出しの右に置く操作 */
  actions?: ReactNode;
  children: ReactNode;
}

export function Card({ title, description, actions, children }: CardProps): ReactNode {
  return (
    <section className="ui-card">
      {title !== undefined || actions !== undefined ? (
        <div className="ui-card-head">
          <div>
            {title !== undefined ? <h2 className="ui-card-title">{title}</h2> : null}
            {description !== undefined ? <p className="ui-card-desc">{description}</p> : null}
          </div>
          {actions !== undefined ? <div className="ui-card-actions">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
